import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import { CreateUserContentRow, UserContentRow } from "./userContent.type";

export const getUserContent = async (
  userId?: string
): Promise<UserContentRow[]> => {
  const slug = ApiEndpoints.userContent + (userId ? `/user/${userId}` : "");

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<UserContentRow[]>(slug, options);
};

export const createUserContent = async (
  data: CreateUserContentRow
): Promise<UserContentRow> => {
  const slug = ApiEndpoints.userContent + "/";

  const options = await setHeaderOptions({ method: "POST", body: data });

  return fetchData<UserContentRow>(slug, options);
};

export const deleteUserContent = async (id: string): Promise<void> => {
  const slug = ApiEndpoints.userContent + `/${id}`;

  const options = await setHeaderOptions({ method: "DELETE" });

  return fetchData<void>(slug, options);
};
